import * as z from 'zod/mini';

export const metaSchema = z.object({
  requestId: z.string(),
  version: z.string(),
  timestamp: z.string(),
});

export type ResponseMeta = z.infer<typeof metaSchema>;

export const apiErrorFieldSchema = z.object({
  field: z.string(),
  code: z.string(),
  message: z.string(),
});

export const apiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  // Empty `details`/`fields` are omitted by the backend; `/choose` BUSINESS_RULE is code + message.
  details: z.optional(z.unknown()),
  fields: z.optional(z.array(apiErrorFieldSchema)),
});

export type ApiErrorBody = z.infer<typeof apiErrorSchema>;

/**
 * Discriminated on `success` so a success payload cannot be read as a failure by accident.
 * All four root keys are required (contract §3).
 */
export function envelopeSchema<T extends z.ZodMiniType>(data: T) {
  return z.discriminatedUnion('success', [
    z.object({
      success: z.literal(true),
      data,
      error: z.null(),
      meta: metaSchema,
    }),
    z.object({
      success: z.literal(false),
      data: z.null(),
      error: apiErrorSchema,
      meta: metaSchema,
    }),
  ]);
}

export interface SuccessEnvelope<T> {
  success: true;
  data: T;
  error: null;
  meta: ResponseMeta;
}
